// react-select renders its menu inside the field by default, so any ancestor with overflow: hidden
// crops the list — the settings dialog does it to round its corners, the form sections do it to clip
// their own edges. Rendering the menu into document.body escapes that, and the z-index clears the
// dialog overlay's 1300.
export const portalledMenu = {
    menuPortalTarget: document.body,
    styles: { menuPortal: base => ({ ...base, zIndex: 1400 }) },
};
